import { createContext, useState, useMemo, ReactNode, useCallback } from 'react'
import { IOpportunityFormPaginationContext } from './types'

// Create the context with an undefined default to enforce provider usage.
export const OpportunityFormPaginationContext = createContext<
  IOpportunityFormPaginationContext | undefined
>(undefined)

interface OpportunityFormPaginationProviderProps {
  children: ReactNode
}

export function OpportunityFormPaginationProvider({
  children,
}: OpportunityFormPaginationProviderProps): JSX.Element {
  // Initialize currentPage state (default value is 1).
  const [currentStep, setCurrentStep] = useState<number>(0)
  const resetCurrentStep = useCallback(() => {
    setCurrentStep(0)
  }, [])

  // Memoize the context value to avoid unnecessary re-renders.
  const value = useMemo(() => {
    return {
      currentStep,
      setCurrentStep,
      resetCurrentStep,
    }
  }, [currentStep, setCurrentStep, resetCurrentStep])

  return (
    <OpportunityFormPaginationContext.Provider value={value}>
      {children}
    </OpportunityFormPaginationContext.Provider>
  )
}
